<template>
  <div class="overflow-hidden mb-6 mt-16" :class="['swiper-gallery-container' + self.id]">
    <div class="swiper-wrapper flex">
      <div v-for="slide in self.slideList" :key="slide.feature" class="flex swiper-slide">
        <div class="flex flex-col justify-between flex-grow w-min">
          <div class="text-white text-button1 font-semibold">{{ t(slide.sub) }}</div>
          <div
            class="text-white text-caption font-medium"
            v-html="
              slide.text === 'text2'
                ? t(slide.text, { likeCount: getState().payment.likeFreeCount })
                : t(slide.text)
            "
          ></div>
        </div>
        <div class="w-32 flex -mr-4">
          <div class="overflow-hidden rounded-full h-16 w-16 border-4 border-white -mr-4">
            <RetinaPhoto
              :photo-id="profile.avatar.id ?? ''"
              :width="56"
              :height="56"
              format="png"
            />
          </div>
          <img class="h-16 w-16" :src="slide.img" alt="" />
        </div>
      </div>
    </div>
    <div
      class="mt-4 flex gap-1 swiper-bullets"
      :class="'swiper-gallery-pagination' + self.id"
    ></div>
  </div>
</template>

<script lang="ts" setup>
import 'swiper/swiper-bundle.css';

import Swiper, { Autoplay, Pagination } from 'swiper';
import { computed, onMounted, PropType } from 'vue';

import RetinaPhoto from '@/components/retina-image/RetinaPhoto.vue';
import { SubscriptionFeature } from '@/components/subscription-promo-modal/helpers/subscription-promo-helper/type/type';
import { MyProfileStateShort } from '@/pages/my-profile/store/my-profile-state';
import { useI18n } from '@/services/i18n';
import { dispatch, getState } from '@/store/store-helper';

import { useSelf } from './hooks/use-self/use-self';
import { messages } from './i18n';

Swiper.use([Pagination, Autoplay]);

const props = defineProps({
  feature: {
    type: String as PropType<SubscriptionFeature>,
    default: undefined,
  },
});

const { t } = useI18n({ messages });

const self = useSelf({
  feature: props.feature,
});

const profile = computed<MyProfileStateShort>(() => {
  return getState().myProfile.short;
});

onMounted(() => {
  self.init();
});

dispatch('actionMyProfileGetShort');
</script>

<style lang="scss">
.swiper-bullets {
  .active {
    opacity: 1;
  }
}
</style>
